import React, { useState } from "react";
import { useGetProjectDetails } from "../../../../../queries/query-hooks/workspace/workspace-hook";
import { useParams } from "react-router-dom";
import { Card } from "react-bootstrap";
import MatrixSkeleton from "../../../../../skeleton/workspace/clirnet/sponsoredContent/MatrixSkeleton";
import TopPerformingContents from "../components/TopPerformingContents";
import IndiaMap from "../../../../../components/chart/IndiaMap";
import MixedColumnChart from "../../../../../components/chart/MixedColumnChart";
import {
  transformCommunityReach,
  transformIndiaMapData,
} from "../utils/commonFunctions";
import {
  useGetCommunityReach,
  useGetContentInfo,
  useGetDashboardInfo,
  useGetLocationInfo,
} from "../../../../../queries/query-hooks/workspace/sponsored-community-hook";
import TopPerformingContentsSkeleton from "../../../../../skeleton/workspace/clirnet/sponsored-community/TopPerformingContentsSkeleton";
import SquareChartSkeleton from "../../../../../skeleton/workspace/clirnet/brand-ads/square-chart-skeleton";
import { ProjectHeaderTopBar, CardNotFound, SummeryMatrix } from "@ui";

const topContentInfoPayload = {
  from: 0,
  to: 10,
  filter: [
    {
      type: "top",
      query: "",
      start_date: "",
      end_date: "",
      content_id: "",
      limit: 3,
      offset: 0,
    },
  ],
};
const locationInfoPayload = {
  type: "views",
  content_id: "",
  content_type: "",
  is_content: false,
};

const Dashboard = () => {
  const { project_id } = useParams();
  const { data: projectDetails, isLoading: isProjectDetailsLoading } =
    useGetProjectDetails(project_id, true);
  const { data: dashboardInfo, isLoading: isDashboardInfoLoading } =
    useGetDashboardInfo(project_id, {}, true);
  const { data: topContentInfoData, isLoading: isTopContentInfoLoading } =
    useGetContentInfo(project_id, topContentInfoPayload, true);
  const { data: locationInfo, isLoading: isLocationInfoLoading } =
    useGetLocationInfo(project_id, locationInfoPayload, true);
  const [filterBy, setFilterBy] = useState("daily");
  const { data: communityReach, isLoading: isCommunityReachLoading } =
    useGetCommunityReach(
      project_id,
      { type: filterBy?.toLowerCase() === "daily" ? "datewise" : "monthwise" },
      true
    );
  const formattedCommunityReach = transformCommunityReach(
    communityReach,
    ["Views", "Reads"],
    ["#3256b8", "#1aa053"],
    filterBy === "Monthly" ? "MMM'YY" : "MMM DD"
  );
  const topContentInfo = topContentInfoData?.rows ?? [];
  const indiaMapData = transformIndiaMapData(locationInfo);

  const updateFilterHandler = (value) => {
    setFilterBy(value);
  };

  return (
    <div>
      <div className="mb-3">
        <ProjectHeaderTopBar
          projectType="CLIRNET Channel"
          title="Summary"
          projectStartDate={projectDetails?.at(0)?.project_start_date || ""}
          projectEndDate={projectDetails?.at(0)?.project_end_date || ""}
          status={projectDetails?.at(0)?.project_status}
          isProjectDetailsLoading={isProjectDetailsLoading}
        />
      </div>

      <Card className="mb-3">
        <Card.Body className="border border-success border-2 rounded-3 border-opacity-25 p-0">
          {!isDashboardInfoLoading ? (
            <SummeryMatrix
              readCount={dashboardInfo?.total_read}
              totalCount={dashboardInfo?.total_views}
              reachCount={dashboardInfo?.total_hcp_engaged}
              contentCount={dashboardInfo?.total_content}
              projectToTargets={{
                project_reads_target: dashboardInfo?.target_reads,
                impressions_target: dashboardInfo?.target_views,
                unique_reach_target: dashboardInfo?.target_engagement,
              }}
              hasViewAccess={true}
              hasReadAccess={true}
              hasHCPAccess={true}
              page="summary"
              title={["Community ", " Dashboard ", " Overview"]}
            />
          ) : (
            <MatrixSkeleton
              title={["Community ", " Dashboard ", " Overview"]}
            />
          )}
        </Card.Body>
      </Card>

      <div className="mb-3">
        {!isTopContentInfoLoading && topContentInfo?.length > 0 ? (
          <TopPerformingContents topPerformingContents={topContentInfo} />
        ) : isTopContentInfoLoading ? (
          <TopPerformingContentsSkeleton />
        ) : (
          <CardNotFound title={`Top Performing`} />
        )}
      </div>

      <div className="mb-3">
        <div className="row">
          <div className="col-md-4 d-flex">
            {!isLocationInfoLoading && locationInfo?.length > 0 ? (
              <IndiaMap
                title={`HCPs Engaged-States`}
                stateData={indiaMapData}
                showStateLegend={false}
                needDownload={true}
                valueSuffix={"%"}
              />
            ) : isLocationInfoLoading ? (
              <SquareChartSkeleton height={320} />
            ) : (
              <CardNotFound title={`HCPs Engaged-States`} />
            )}
          </div>

          <div className="col-md-8 d-flex">
            {!isCommunityReachLoading && communityReach?.length > 0 ? (
              <MixedColumnChart
                title={"Community Reach"}
                labels={formattedCommunityReach.labels}
                series={formattedCommunityReach.series}
                showDownloadButtons={false}
                showDropdown={true}
                filterBy={filterBy}
                updateFilterHandler={updateFilterHandler}
              />
            ) : isCommunityReachLoading ? (
              <SquareChartSkeleton height={320} />
            ) : (
              <CardNotFound title={"Community Reach"} height={320} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
